module.exports = __webpack_public_path__ + "img/smartphone.eab39aa7.png";